var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsis = function SvgEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 4,
    fill: "none",
    viewBox: "0 0 10 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M1.25 3.125a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m3.75 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m3.75 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25"
  })));
};
export default SvgEllipsis;